import { RG62 } from "./SalesPerfSummary/RG62"
import { RG31 } from "./ShareByDistrict/RG31"
import { RG34 } from "./ActualTarget/RG34"
import { RG33 } from "./ActualLastYear/RG33"
import { RG68_04 } from "./EmployeeComparativeSales/RG68_04"
import { RG68_05 } from "./EmployeeGrowthPerformance/RG68_05"
import { RG68 } from "./SalesPerformanceByDM/RG68"
import { RG68_12 } from "./DistrictComparativeMonthly/RG68_12"
import { RG68_21 } from "./SalesPerformancePerArea/RG68_21"

export const RegionComparativeSalesPerf = {
  "sections": [
    RG62,
    RG31,
    RG34,
    RG33,
    RG68,
    RG68_12,
    RG68_04,
    RG68_05,
    RG68_21
  ]
}